module.exports = __webpack_public_path__ + "img/img-logo-eyezen-start.16a5b3a2.svg";